<modal
  [id]="id()"
  [header]="'Add from other event'"
  [headerIcon]="headerIcon"
  [closeButtonEnabled]="!isSubmitting()"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-[343px] lg:tw-w-[576px]'"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="!isSubmitting()"
  [escapeToClose]="!isSubmitting()"
>
  <div slot="body" class="tw-flex tw-flex-col tw-gap-8 tw-py-2 tw-font-inter">
    <div class="tw-flex tw-flex-col tw-gap-3">
      <select-input
        class="tw-w-full"
        [id]="'add_from_other_event_event'"
        [control]="eventControl"
        [label]="'Event'"
        key="name"
        valueName="id"
        [values]="eventOptions()"
        [isDropdown]="true"
        [basicSelect]="true"
        [isBasicDropdownValue]="true"
        [enableSearch]="true"
        [isSingleSelect]="true"
        [clear]="true"
        [required]="true"
        [dropdownMaxHeightInPX]="optionsMaxHeight"
        [optionNoData]="isLoadingEvents() ? 'Loading events...' : 'No events found'"
      ></select-input>

      <div class="tw-relative" (focusin)="onPersonaFieldEntered()">
        <select-input
          class="tw-w-full"
          [id]="'add_from_other_event_persona'"
          [control]="personaControl"
          [label]="'Persona'"
          key="name"
          valueName="id"
          [values]="personaOptions()"
          [isDropdown]="true"
          [basicSelect]="true"
          [isBasicDropdownValue]="true"
          [enableSearch]="true"
          [isSingleSelect]="true"
          [clear]="true"
          [required]="true"
          [dropdownMaxHeightInPX]="optionsMaxHeight"
          [optionNoData]="personaNoDataMessage()"
        ></select-input>
        @if (!selectedEvent()) {
        <button
          type="button"
          tabindex="-1"
          class="tw-absolute tw-inset-0 tw-z-20 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
          aria-label="Persona"
          (click)="onPersonaFieldEntered()"
        ></button>
        }
      </div>
    </div>

    <button
      type="button"
      class="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-blue-600 tw-px-6 tw-py-2.5 tw-font-inter tw-text-sm tw-font-medium tw-leading-normal tw-text-white tw-cursor-pointer tw-transition-colors hover:tw-bg-blue-700 lg:tw-h-[52px] lg:tw-py-3.5 lg:tw-text-base"
      [buttonSpinner]="isSubmitting()"
      (click)="onConfirm()"
    >
      Confirm
    </button>
  </div>
</modal>
